import React, { useEffect } from "react";
import ReactTooltip from "react-tooltip";
import { Context } from "../../../config/store";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import LenderUgroService from "../../../services/lender";
import EligibleLenderUserModal from "../../../components/Portfolio/EligibleLenderModel";
import { toast } from "react-toastify";

const LenderName = ({ row, field, reloadTable }) => {
  const [modalState, toggleModal] = React.useState(false);
  const [users, setUsers] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const { state } = React.useContext(Context);
  const location = useLocation();

  //   const checkHasPermission = (checkPermission) => {
  //     if (state.is_super_admin === 1) return true;
  //     const permission = state.permission.find(
  //       (permission) => permission === checkPermission
  //     );

  //     if (permission) return true;
  //     else return false;
  //   };
  const toggleModalState = () => toggleModal(!modalState);

  const getAllLenderList = async (option) => {
    setLoading(true);
    try {
      let response;
      response = await LenderUgroService.getEligibleNonEligibleUsers({
        type: state.userType,
        leadId: row.cl_lead_id,
        option
      });
      if (response?.data?.status?.code === 1) {
        setUsers(response?.data?.data);
        if(option){
          toast.success(response?.data?.messages?.success?.others.join())
        }
        setLoading(false);
      } else {
        toast.error(response?.data?.messages?.error?.others.join())
      }
    } catch (err) {
      setLoading(false);
    }
  };
  const isDisbursalRoute = () => {
    return (
      <>
        {row.status_id === 1 || row.status_id === 5 ? (
          <>
            {/* <ReactTooltip id={"lender-name" + row.cl_lead_id}>
              <span>{row.eligible_lenders}</span>
            </ReactTooltip> */}
            <span
              className="tooltip-column-text"
              data-tip
              data-for={"lender-name" + row.cl_lead_id}
              onClick={toggleModalState}
            >
              Eligible Lender
            </span>
          </>
        ) : (
          <span>{row.lender_name}</span>
        )}
        {modalState && (
          <EligibleLenderUserModal
            loading={loading}
            modelState={modalState}
            toggleModal={toggleModalState}
            allLenderList={users}
            selectedIds={row.cl_lead_id}
            reloadTable={getAllLenderList}
            getAllLenderList={getAllLenderList}

          />
        )}
      </>
    );
  };
  const notDisbursalRoute = () => {
    return (
      <>
        {row.status_id === 1 || row.status_id === 5 ? (
          <>
            {/* <ReactTooltip id={"lender-name" + row.cl_lead_id}>
              <span>{row.eligible_lenders}</span>
            </ReactTooltip> */}
            <span
              className="tooltip-column-text"
              data-tip
              data-for={"lender-name" + row.cl_lead_id}
            >
              Eligible Lender
            </span>
          </>
        ) : (
          <span>{row.lender_name}</span>
        )}
      </>
    );
  };

  if (state.userType === "lender") {
    return notDisbursalRoute();
  } else if (state.userType === "admin") {
    return isDisbursalRoute();
  }
};

export default LenderName;
